'use client';

import { Search, X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  'aria-label'?: string;
  /** Caps what can be typed or pasted into the box. */
  maxLength?: number;
  /** Id of an element that explains the box (e.g. a hint naming its limit). */
  'aria-describedby'?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  'aria-label': ariaLabel,
  maxLength,
  'aria-describedby': ariaDescribedBy,
}: SearchInputProps) {
  return (
    <div className={`flex w-full items-center gap-2 ${className}`}>
      <div className="relative flex-1">
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-12 w-full rounded-xl border border-transparent bg-white pl-4 pr-10 text-sm text-foreground placeholder:text-foreground-muted focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label={ariaLabel || placeholder}
          aria-describedby={ariaDescribedBy}
          maxLength={maxLength}
          autoComplete="off"
          data-testid="search-input-input"
        />
        {value.length > 0 && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 flex h-6 w-6 items-center justify-center rounded-full border border-border text-foreground-muted transition hover:border-foreground hover:text-foreground"
            aria-label="Clear search"
            data-testid="search-input-clear-btn"
          >
            <X size={12} aria-hidden="true" />
          </button>
        )}
      </div>
      <button
        type="button"
        onClick={() => onChange(value)}
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-action-green text-black transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        aria-label="Search"
        data-testid="search-input-submit-btn"
      >
        <Search size={20} aria-hidden="true" />
      </button>
    </div>
  );
}

